"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M2.576 14.265c-.384-.383-.576-.86-.576-1.427 0-.567.192-1.042.576-1.426l8.81-8.811A2.066 2.066 0 0 1 12.838 2h7.16c.55 0 1.022.196 1.414.588.392.392.588.864.588 1.415v7.159c0 .283-.054.55-.163.8a2.08 2.08 0 0 1-.438.651l-8.836 8.811A1.923 1.923 0 0 1 11.15 22a1.92 1.92 0 0 1-1.414-.576l-7.16-7.159Zm13.416-7.76c0 .418.146.772.438 1.064.293.292.647.439 1.064.439.418 0 .772-.147 1.064-.439.292-.292.438-.646.438-1.063 0-.418-.146-.772-.438-1.064a1.448 1.448 0 0 0-1.064-.438 1.45 1.45 0 0 0-1.064.438 1.448 1.448 0 0 0-.438 1.064Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};